import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sharedActions } from "../../../store";

import PopUpModal from "../PopUpModal/PopUpModal";
import { generateShareLink } from "../../../Helpers/ShareHelper";

import styles from "./ShareModal.module.css";

export default function ShareModal({ isOpen, onClose }) {
    const dispatch = useDispatch();
    const shareData = useSelector((state) => state.shared.shareData);
    const [shareLink, setShareLink] = useState("Choose a product first");
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (isOpen) {
            generateShareLink().then(result => {
                dispatch(sharedActions.setShareData(result));
            });
        }
    }, [isOpen, dispatch]);

    useEffect(() => {
        if (shareData?.url) {
            setShareLink(shareData.url);
        }
    }, [shareData]);

    const handleCopy = () => {
        navigator.clipboard.writeText(shareLink).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    if (!isOpen) {
        return null;
    }

    return (
        <PopUpModal handleClose={onClose}>
            <div className={styles.contentMain}>
                <h2>Share Your Project</h2>
                <p id="success-message">{copied && "Copied!"}</p>
                <div className={styles.shareInput}>
                    <input
                        type="text"
                        id="project-link"
                        value={shareLink}
                        readOnly
                        style={{ flex: 1 }}
                    />
                    <button onClick={handleCopy}>Copy</button>
                </div>
            </div>
        </PopUpModal>
    );
}
